<template>
  <div class="main-content wide">
    <div class="wrap">
      <div class="page-title">
        {{ pageData.pageTitle }}
      </div>
      <div class="top-block">
        <div class="subtitle">
          {{ pageData.subtitle }}
        </div>
        <div class="description">
          {{ pageData.description }}
        </div>
      </div>
      <search
        class="white"
        :placeholder="$t('header.preHeader.search')"
        :search-page-url="searchPageUrl"
        :results-page-visible="resultsPageVisible"
      />

      <div class="description">
        {{ pageData.searchDescription }}
      </div>
      <div class="buttons-block">
        <div
          class="btn btn-ghost"
          @click="goBack()"
        >
          <a>{{ pageData.backButton }}</a>
        </div>
        <div class="btn btn-blue">
          <a href="/">{{ pageData.homeButton }}</a>
        </div>
      </div>

      <div class="description">
        {{ pageData.discoverDescription }}
      </div>
      <div class="discover-block">
        <a
          v-for="(discoverItem, index) in discoverNews"
          :key="index"
          class="discover-item"
          :href="discoverItem.href"
        >
          <img
            v-if="isTablet && discoverItem.tabletImg"
            :src="discoverItem.tabletImg"
            :alt="discoverItem.altText"
          >
          <img
            v-else-if="discoverItem.img"
            :src="discoverItem.img"
            :alt="discoverItem.altText"
          >
          <div class="title">{{ discoverItem.title }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Search from 'components/Search/Search'

  export default {
    components: {
      Search
    },
    computed: {
      ...mapGetters('device', [
        'isTablet'
      ]),
      ...mapState('404', [
        'pageData',
        'discoverNews'
      ]),

      ...mapState('search', [
        'searchPageUrl',
        'resultsPageVisible'
      ])
    },
    methods: {
      goBack () {
        window.history.back()
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .wrap {
    padding: 0 23px 50px;
    position: relative;

    @include bp-mf-tablet {
      padding: 55px 26px 50px;
    }

    @include bp-mf-desktop {
      padding: 90px 0 100px;
    }
  }

  .top-block {
    @include bp-mf-desktop {
      width: calc(100% - 355px);
    }

    .description {
      color: $grey-default;
    }
  }

  .page-title {
    line-height: 79px;
    font-size: em(60);
    font-weight: 700;
    color: #E2E2E2;

    @include bp-mf-tablet {
      font-size: em(100);
      margin-bottom: 30px;
    }

    @include bp-mf-desktop {
      position: absolute;
      right: 75px;
      font-size: em(160);
      line-height: 120px;
    }

    @include bp-desktop-small {
      right: 26px;
    }
  }

  .subtitle {
    margin-bottom: 10px;
    font-size: em(30);
    font-weight: 300;

    @include bp-mf-tablet {
      font-size: em(40);
      line-height: 53px;
    }

    @include bp-mf-desktop {
      font-size: em(50);
      line-height: 66px;
    }
  }

  .description {
    color: $grey;
    font-size: em(14);
    line-height: 19px;

    @include bp-mf-tablet {
      font-size: em(20);
      line-height: 26px;
    }

    @include bp-mf-desktop {
      font-size: em(22);
      line-height: 29px;
    }
  }

  .main-content /deep/ .search-container.white {
    height: 40px;
    margin: 32px 0 15px;
    border-bottom: 1.5px solid #DFE0E3;

    @include bp-mf-desktop {
      height: 42px;
      margin: 55px 0 20px;
      padding-left: 35px;
    }

    &:before {
      line-height: 35px;
      color: $grey-default;
    }

    input {
      height: 35px;
      font-size: em(18);
      @include input-placeholder {
        color: $grey-default;
      }

      @include bp-mf-desktop {
        font-size: em(24);
      }
    }
  }

  .buttons-block {
    margin: 40px auto;

    .btn {
      display: inline-block;
      min-width: 124px;
      height: 48px;
      line-height: 48px;
    }

    @include bp-mf-desktop {
      height: 52px;
      line-height: 52px;
    }

    .btn-ghost {
      margin-right: 20px;
    }
  }

  .discover-block {
    @include bp-mf-desktop {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
    }
  }

  .discover-item {
    display: block;
    margin-top: 25px;
    text-decoration: none;

    @include bp-mf-desktop {
      width: calc((100% / 3) - 15px);
      margin: 0;
      display: inline-block;
    }

    &:hover {

      .title {
        background-color: $gray-light-hover;
      }
    }

    img {
      display: block;
      width: 100%;
    }

    .title {
      height: 95px;
      padding: 0 27px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: $grey-the-whitest;
      border-radius: 0 0 6px 6px;
      text-align: center;
      font-size: em(18);
      font-weight: 500;
      color: $blue-medium;

      @include bp-tablet-only {
        height: 170px;
        font-size: em(28);
        line-height: 37px;
      }

      @include bp-mf-desktop {
        height: 130px;
        font-size: em(24);
        line-height: 28px;
      }
    }
  }
</style>
